import styled from "styled-components";

export const Container = styled.div`
  align-self: center;
  display: flex;
  justify-content: center;
  label {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    img {
      height: auto;
      width: 320px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      background: #eee;
      margin-top: 30px;
    }
    input {
      display: none;
    }
  }
`;

export const DefaultAvatar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 320px;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  margin-top: 30px;

  @media (max-width: 1700px){
    width: 200px;
  }

  span {
    color: #ddd;
    font-size: 16px;
    font-weight: bold;
  }
`;

